import {
  faExternalLinkAlt,
  faInfoCircle
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Card, OverlayTrigger, Popover, Table } from 'react-bootstrap';
import LoadingOverlay from '../LoadingOverlay';

function PropertyGroups(props) {
  return (
    <Card>
      <Card.Header
        style={{ height: '63px' }}
        className='d-flex align-items-center'
      >
        Property Groups
        <OverlayTrigger
          trigger='hover'
          overlay={
            <Popover>
              <Popover.Content>
                Listing of the groups that this property has been assigned to.
                However, it only shows the groups that you have access to. So
                this property may appear in more groups not shown here.
              </Popover.Content>
            </Popover>
          }
        >
          <FontAwesomeIcon icon={faInfoCircle} className='ml-2' />
        </OverlayTrigger>
      </Card.Header>
      <Card.Body>
        <Table>
          <thead>
            <tr>
              <th>Name</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {props.propertyGroups.map((propertyGroup) => (
              <tr key={propertyGroup.id}>
                <td>{propertyGroup.name}</td>
                <td>
                  <Button
                    variant='link'
                    className='text-primary'
                    onClick={() => {
                      props.linkTo(
                        `/management/property-groups/${propertyGroup.id}`
                      );
                    }}
                  >
                    <FontAwesomeIcon icon={faExternalLinkAlt} />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {props.loading ? <LoadingOverlay /> : null}
      </Card.Body>
    </Card>
  );
}

PropertyGroups.propTypes = {
  propertyGroups: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  linkTo: PropTypes.func.isRequired
};

export default PropertyGroups;
